import * as React from 'react';
import { useConstant } from '@workwave-tidal/core/hooks'
import { type PropsWithChildren, createContext, useContext } from 'react'

export const wormholeIdContext = createContext<string>(window.crypto.randomUUID())

export function WormholeIdProvider(props: PropsWithChildren) {
  const { children } = props

  const id = useConstant(() => window.crypto.randomUUID())

  return <wormholeIdContext.Provider value={id}>{children}</wormholeIdContext.Provider>
}

export function useWormholeId(worm: 'headerActions' | 'headerContent' | 'editorActions' | 'editorSuggestions') {
  const ctx = useContext(wormholeIdContext)

  return `${ctx}-${worm}`
}
